import React, { useState, useEffect } from 'react';
import api from '../services/api';
import AdminLayout from '../components/Layout/AdminLayout';


const Hadith = () => {
  const [hadiths, setHadiths] = useState([]);
  const [collections, setCollections] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('hadiths');
  const [showModal, setShowModal] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showCollectionModal, setShowCollectionModal] = useState(false);
  const [editingHadith, setEditingHadith] = useState(null);
  const [editingCategory, setEditingCategory] = useState(null);
  const [editingCollection, setEditingCollection] = useState(null);
  const [formData, setFormData] = useState({
    collectionId: '',
    categoryId: '',
    hadithNumber: '',
    arabicText: '',
    translation: '',
    narrator: '',
    grade: 'صحيح',
    explanation: '',
    isActive: true
  });
  const [categoryFormData, setCategoryFormData] = useState({
    nameAr: '',
    nameEn: '',
    description: ''
  });
  const [collectionFormData, setCollectionFormData] = useState({
    nameAr: '',
    nameEn: '',
    description: ''
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [hadithsRes, collectionsRes, categoriesRes] = await Promise.all([
        api.get('/hadith/admin/all'),
        api.get('/hadith/collections'),
        api.get('/hadith/categories')
      ]);
      setHadiths(hadithsRes.data);
      setCollections(collectionsRes.data);
      setCategories(categoriesRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      alert('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingHadith) {
        await api.put(`/hadith/admin/${editingHadith.id}`, formData);
        alert('تم تحديث الحديث بنجاح');
      } else {
        await api.post('/hadith/admin', formData);
        alert('تم إضافة الحديث بنجاح');
      }
      setShowModal(false);
      resetForm();
      fetchData();
    } catch (error) {
      console.error('Error saving hadith:', error);
      alert('فشل في حفظ الحديث');
    }
  };

  const handleEdit = (hadith) => {
    setEditingHadith(hadith);
    setFormData({
      collectionId: hadith.collectionId,
      categoryId: hadith.categoryId || '',
      hadithNumber: hadith.hadithNumber,
      arabicText: hadith.arabicText,
      translation: hadith.translation || '',
      narrator: hadith.narrator,
      grade: hadith.grade,
      explanation: hadith.explanation || '',
      isActive: hadith.isActive
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذا الحديث؟')) {
      try {
        await api.delete(`/hadith/admin/${id}`);
        alert('تم حذف الحديث بنجاح');
        fetchData();
      } catch (error) {
        console.error('Error deleting hadith:', error);
        alert('فشل في حذف الحديث');
      }
    }
  };

  const handleSetHadithOfDay = async (id) => {
    if (window.confirm('هل تريد تعيين هذا الحديث كحديث اليوم؟')) {
      try {
        await api.put(`/hadith/admin/${id}/set-hadith-of-day`);
        alert('تم تعيين حديث اليوم بنجاح');
        fetchData();
      } catch (error) {
        console.error('Error setting hadith of the day:', error);
        alert('فشل في تعيين حديث اليوم');
      }
    }
  };

  const resetForm = () => {
    setEditingHadith(null);
    setFormData({
      collectionId: '',
      categoryId: '',
      hadithNumber: '',
      arabicText: '',
      translation: '',
      narrator: '',
      grade: 'صحيح',
      explanation: '',
      isActive: true
    });
  };

  const getCollectionName = (id) => {
    const collection = collections.find(c => c.id === id);
    return collection ? collection.nameAr : '';
  };

  const getCategoryName = (id) => {
    const category = categories.find(c => c.id === id);
    return category ? category.nameAr : '';
  };

  const handleCategorySubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingCategory) {
        await api.put(`/hadith/admin/categories/${editingCategory.id}`, categoryFormData);
        alert('تم تحديث التصنيف بنجاح');
      } else {
        await api.post('/hadith/admin/categories', categoryFormData);
        alert('تم إضافة التصنيف بنجاح');
      }
      setShowCategoryModal(false);
      setCategoryFormData({ nameAr: '', nameEn: '', description: '' });
      setEditingCategory(null);
      fetchData();
    } catch (error) {
      console.error('Error saving category:', error);
      alert('فشل في حفظ التصنيف');
    }
  };

  const handleDeleteCategory = async (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذا التصنيف؟')) {
      try {
        await api.delete(`/hadith/admin/categories/${id}`);
        alert('تم حذف التصنيف بنجاح');
        fetchData();
      } catch (error) {
        console.error('Error deleting category:', error);
        alert('فشل في حذف التصنيف');
      }
    }
  };

  const handleCollectionSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingCollection) {
        await api.put(`/hadith/admin/collections/${editingCollection.id}`, collectionFormData);
        alert('تم تحديث المصدر بنجاح');
      } else {
        await api.post('/hadith/admin/collections', collectionFormData);
        alert('تم إضافة المصدر بنجاح');
      }
      setShowCollectionModal(false);
      setCollectionFormData({ nameAr: '', nameEn: '', description: '' });
      setEditingCollection(null);
      fetchData();
    } catch (error) {
      console.error('Error saving collection:', error);
      alert('فشل في حفظ المصدر');
    }
  };

  const handleDeleteCollection = async (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذا المصدر؟')) {
      try {
        await api.delete(`/hadith/admin/collections/${id}`);
        alert('تم حذف المصدر بنجاح');
        fetchData();
      } catch (error) {
        console.error('Error deleting collection:', error);
        alert('فشل في حذف المصدر');
      }
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center min-h-96">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-gold"></div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="p-6" dir="rtl">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">إدارة الأحاديث</h1>
          <div className="flex gap-2">
            {activeTab === 'hadiths' && (
              <button
                onClick={() => {
                  resetForm();
                  setShowModal(true);
                }}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                إضافة حديث جديد
              </button>
            )}
            {activeTab === 'categories' && (
              <button
                onClick={() => {
                  setEditingCategory(null);
                  setCategoryFormData({ nameAr: '', nameEn: '', description: '' });
                  setShowCategoryModal(true);
                }}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                إضافة تصنيف جديد
              </button>
            )}
            {activeTab === 'collections' && (
              <button
                onClick={() => {
                  setEditingCollection(null);
                  setCollectionFormData({ nameAr: '', nameEn: '', description: '' });
                  setShowCollectionModal(true);
                }}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                إضافة مصدر جديد
              </button>
            )}
          </div>
        </div>

        <div className="mb-6 border-b border-gray-200">
          <nav className="flex gap-4">
            <button
              onClick={() => setActiveTab('hadiths')}
              className={`pb-2 px-4 ${activeTab === 'hadiths' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
            >
              الأحاديث
            </button>
            <button
              onClick={() => setActiveTab('categories')}
              className={`pb-2 px-4 ${activeTab === 'categories' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
            >
              التصنيفات
            </button>
            <button
              onClick={() => setActiveTab('collections')}
              className={`pb-2 px-4 ${activeTab === 'collections' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500'}`}
            >
              المصادر
            </button>
          </nav>
        </div>

        {activeTab === 'hadiths' && (
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">رقم الحديث</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">المصدر</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">التصنيف</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الراوي</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الدرجة</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">حديث اليوم</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الحالة</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الإجراءات</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {hadiths.map((hadith) => (
                <tr key={hadith.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{hadith.hadithNumber}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{getCollectionName(hadith.collectionId)}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{getCategoryName(hadith.categoryId)}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{hadith.narrator}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span className={`px-2 py-1 rounded text-xs ${
                      hadith.grade === 'صحيح' ? 'bg-green-100 text-green-800' :
                      hadith.grade === 'حسن' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-red-100 text-red-800'
                    }`}>
                      {hadith.grade}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    {hadith.isHadithOfDay && <span className="text-yellow-600">⭐</span>}
                    }
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    <span className={`px-2 py-1 rounded text-xs ${
                      hadith.isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                    }`}>
                      {hadith.isActive ? 'نشط' : 'غير نشط'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm space-x-2 space-x-reverse">
                    <button
                      onClick={() => handleSetHadithOfDay(hadith.id)}
                      className="text-yellow-600 hover:text-yellow-900"
                      title="تعيين كحديث اليوم"
                    >
                      ⭐
                    </button>
                    <button
                      onClick={() => handleEdit(hadith)}
                      className="text-blue-600 hover:text-blue-900"
                    >
                      تعديل
                    </button>
                    <button
                      onClick={() => handleDelete(hadith.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      حذف
                    </button>
                  </td>
                </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 'categories' && (
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الاسم بالعربية</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الاسم بالإنجليزية</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الوصف</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الإجراءات</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {categories.map((category) => (
                  <tr key={category.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{category.nameAr}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{category.nameEn}</td>
                    <td className="px-6 py-4 text-sm text-gray-800">{category.description}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm space-x-2 space-x-reverse">
                      <button
                        onClick={() => {
                          setEditingCategory(category);
                          setCategoryFormData({
                            nameAr: category.nameAr,
                            nameEn: category.nameEn,
                            description: category.description || ''
                          });
                          setShowCategoryModal(true);
                        }}
                        className="text-blue-600 hover:text-blue-900"
                      >
                        تعديل
                      </button>
                      <button
                        onClick={() => handleDeleteCategory(category.id)}
                        className="text-red-600 hover:text-red-900"
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 'collections' && (
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الاسم بالعربية</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الاسم بالإنجليزية</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الوصف</th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">الإجراءات</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {collections.map((collection) => (
                  <tr key={collection.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{collection.nameAr}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{collection.nameEn}</td>
                    <td className="px-6 py-4 text-sm text-gray-800">{collection.description}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm space-x-2 space-x-reverse">
                      <button
                        onClick={() => {
                          setEditingCollection(collection);
                          setCollectionFormData({
                            nameAr: collection.nameAr,
                            nameEn: collection.nameEn,
                            description: collection.description || ''
                          });
                          setShowCollectionModal(true);
                        }}
                        className="text-blue-600 hover:text-blue-900"
                      >
                        تعديل
                      </button>
                      <button
                        onClick={() => handleDeleteCollection(collection.id)}
                        className="text-red-600 hover:text-red-900"
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto text-gray-900">
              <h2 className="text-xl font-bold mb-4 text-gray-900">
                {editingHadith ? 'تعديل حديث' : 'إضافة حديث جديد'}
              </h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">المصدر *</label>
                  <select
                    value={formData.collectionId}
                    onChange={(e) => setFormData({ ...formData, collectionId: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    required
                  >
                    <option value="">اختر المصدر</option>
                    {collections.map((collection) => (
                      <option key={collection.id} value={collection.id}>
                        {collection.nameAr}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">التصنيف</label>
                  <select
                    value={formData.categoryId}
                    onChange={(e) => setFormData({ ...formData, categoryId: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                  >
                    <option value="">اختر التصنيف</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.nameAr}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">رقم الحديث *</label>
                  <input
                    type="text"
                    value={formData.hadithNumber}
                    onChange={(e) => setFormData({ ...formData, hadithNumber: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">نص الحديث بالعربية *</label>
                  <textarea
                    value={formData.arabicText}
                    onChange={(e) => setFormData({ ...formData, arabicText: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    rows="4"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الترجمة</label>
                  <textarea
                    value={formData.translation}
                    onChange={(e) => setFormData({ ...formData, translation: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    rows="3"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الراوي *</label>
                  <input
                    type="text"
                    value={formData.narrator}
                    onChange={(e) => setFormData({ ...formData, narrator: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الدرجة *</label>
                  <select
                    value={formData.grade}
                    onChange={(e) => setFormData({ ...formData, grade: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    required
                  >
                    <option value="صحيح">صحيح</option>
                    <option value="حسن">حسن</option>
                    <option value="ضعيف">ضعيف</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الشرح</label>
                  <textarea
                    value={formData.explanation}
                    onChange={(e) => setFormData({ ...formData, explanation: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    rows="3"
                  />
                </div>

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="isActive"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                    className="mr-2"
                  />
                  <label htmlFor="isActive" className="text-sm font-medium text-gray-700">نشط</label>
                </div>

                <div className="flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setShowModal(false);
                      resetForm();
                    }}
                    className="px-4 py-2 border rounded hover:bg-gray-100"
                  >
                    إلغاء
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    حفظ
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {showCategoryModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full text-gray-900">
              <h2 className="text-xl font-bold mb-4 text-gray-900">
                {editingCategory ? 'تعديل تصنيف' : 'إضافة تصنيف جديد'}
              </h2>
              <form onSubmit={handleCategorySubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الاسم بالعربية *</label>
                  <input
                    type="text"
                    value={categoryFormData.nameAr}
                    onChange={(e) => setCategoryFormData({ ...categoryFormData, nameAr: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الاسم بالإنجليزية</label>
                  <input
                    type="text"
                    value={categoryFormData.nameEn}
                    onChange={(e) => setCategoryFormData({ ...categoryFormData, nameEn: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الوصف</label>
                  <textarea
                    value={categoryFormData.description}
                    onChange={(e) => setCategoryFormData({ ...categoryFormData, description: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    rows="3"
                  />
                </div>
                <div className="flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setShowCategoryModal(false);
                      setCategoryFormData({ nameAr: '', nameEn: '', description: '' });
                      setEditingCategory(null);
                    }}
                    className="px-4 py-2 border rounded hover:bg-gray-100"
                  >
                    إلغاء
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    حفظ
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {showCollectionModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full text-gray-900">
              <h2 className="text-xl font-bold mb-4 text-gray-900">
                {editingCollection ? 'تعديل مصدر' : 'إضافة مصدر جديد'}
              </h2>
              <form onSubmit={handleCollectionSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الاسم بالعربية *</label>
                  <input
                    type="text"
                    value={collectionFormData.nameAr}
                    onChange={(e) => setCollectionFormData({ ...collectionFormData, nameAr: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الاسم بالإنجليزية</label>
                  <input
                    type="text"
                    value={collectionFormData.nameEn}
                    onChange={(e) => setCollectionFormData({ ...collectionFormData, nameEn: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-gray-700">الوصف</label>
                  <textarea
                    value={collectionFormData.description}
                    onChange={(e) => setCollectionFormData({ ...collectionFormData, description: e.target.value })}
                    className="w-full border rounded px-3 py-2 text-gray-900 bg-white"
                    rows="3"
                  />
                </div>
                <div className="flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={() => {
                      setShowCollectionModal(false);
                      setCollectionFormData({ nameAr: '', nameEn: '', description: '' });
                      setEditingCollection(null);
                    }}
                    className="px-4 py-2 border rounded hover:bg-gray-100"
                  >
                    إلغاء
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    حفظ
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default Hadith;
